// import AlertsContext from 'common/contexts/alerts';
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import useList from "common/hooks/useList";
import {
  // eslint-disable-next-line comma-dangle
  useCallback,
  useContext,
  useEffect,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";

import { AlertType } from "types/AlertType";

import Header from "common/components/Header/Header";
import FilteredList from "common/components/Table/FilteredList";
import useAuth from "common/hooks/useAuth";
import AlertsContext from "common/providers/alerts";
import { TbBellCog } from "react-icons/tb";
import AlertTypeItem from "./AlertTypeItem";

function AlertTypes() {
  const { t } = useTranslation();
  const { navigate } = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const { user: currentUser } = useAuth();

  const {
    fetchItems,
    items,
    isFetching,
    filters,
    setFilter,
    pageCount,
    setPageIndex,
    pageIndex,
    removeListItem,
    itemsCount,
    itemsPerPage,
    error,
  } = useList<AlertType>("alert-types", {
    defaultSort: "name:ASC",
    populate: ["icon"],
  });

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const { removeItem } = useItem<AlertType>("alert-types", "");

  const handleDelete = useCallback(
    async (id: any) => {
      try {
        removeListItem(id);
        await removeItem(id);
        fetchItems();
      } catch (e) {
        setAlert(e, "danger");
        return e;
      }
      return true;
    },
    [removeListItem, removeItem, fetchItems, setAlert]
  );

  const handleNavigate = (id: any) => {
    navigate(`/alert-types/edit/${id}`);
  };

  /* const { setAlert } = useContext(AlertsContext);

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]); */

  const columns = useMemo(
    () => [
      {
        Header: t("forms.name"),
        filterName: "name$contains",
        filterLabel: t("filters.search"),
        columnClasses: "md:flex-[2]",
      } /* ,
      {
        Header: t("forms.icon"),
        columnClasses: "md:flex-1",
      } */,
    ],
    [t]
  );

  return (
    <div className="mx-auto max-w-full py-4 px-4 text-slate-500">
      <Header
        title={t("titlePages.alertTypes")}
        subtitle={t("titleLegends.alertTypes")}
        btnTitle={t("newItem.alertType")}
        btnSubtitle={t("newItem.alertTypeLegend")}
        Icon={TbBellCog}
        addLink="/alert-types/add"
        addLinkDisabled={!currentUser?.isAdmin && !currentUser?.isSuperadmin}
        isBeforeFilters
      />

      <FilteredList
        data={items ?? []}
        columns={columns} // used as filter items
        isFetching={isFetching}
        pageCount={pageCount}
        filters={filters}
        setFilter={setFilter}
        setPageIndex={setPageIndex}
        pageIndex={pageIndex}
        RenderItem={AlertTypeItem}
        onDelete={handleDelete}
        onNavigate={handleNavigate}
        itemsCount={itemsCount}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
}

export default AlertTypes;
